import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ContactAutocompleteService, ContactAutocompleteResult, ContactDetails } from 'src/app/services/contacts/contact-autocomplete.service';
import { IAddressOption } from 'src/app/freightmancerlvl99/freightmancerlvl99.models';


@Component({
  selector: 'app-client-scopes-add',
  templateUrl: './client-scopes-add.component.html',
  styleUrls: ['./client-scopes-add.component.scss']
})
export class ClientScopesAddComponent {
  scopeForm!: FormGroup;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private dialog: MatDialogRef<ClientScopesAddComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {customer_contact_uuid: string}
  ){

  }

  ngOnInit(){
    this.scopeForm = this.fb.group({
      reference_code: [''],
      reference_scope: ['', Validators.required],
      contact_scac: ['', Validators.required],
      contact_uuid: ['', Validators.required],
      contact_name: ['']
    });
  }

  get contactControl(){
    return this.scopeForm.get('contact_name') as FormControl;
  }

  onContactSelected(selected: ContactAutocompleteResult){
    this.scopeForm.patchValue({
      contact_uuid: selected.value
    });
  }

  close(){
    this.dialog.close();
  }

  submit(){
    if (!this.scopeForm.valid){
      this.toastr.error('Please fill out all fields before submitting');
      return;
    }
    const url = '/api/pool_points/pool_point_scopes.php';
    const postBody = {
      reference_code: this.scopeForm.get('reference_code')?.value,
      reference_scope: this.scopeForm.get('reference_scope')?.value,
      contact_uuid: this.scopeForm.get('contact_uuid')?.value,
      customer_contact_uuid: this.data.customer_contact_uuid,
      contact_scac: this.scopeForm.get('contact_scac')?.value
    }
    this.http.post<any>(url, postBody).subscribe(
      response => {
        console.log(response)
        this.close();
      },
      error => {
        console.error(error)
      }
    )
  }
}
